<template>
  <nav class="navbar-topo">
    <button class="btn btn-transparent" @click="changeStatus(!collapsed)">
      <feather class="grid-icon" type="grid" size="16" />
    </button>
    <div class="user-data">
      <b-dropdown v-model="navigation" position="is-bottom-left">
        <a slot="trigger" class="navbar-item" role="button">
          <div class="user-personal-info">
            <h1 style="text-transform: capitalize;" class="title-username">
              Bem Vindo{{ "(a)" }} {{ jwtDecoded.usuario }}
            </h1>
            <feather class="user-icon" type="user" size="20px" />
          </div>
        </a>
        <b-dropdown-item @click="logoff()">
          <div class="dropdown-exit">
            <feather class="dropdown-menu-icon" type="log-out" size="16" />
            Sair
          </div>
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </nav>
</template>

<script>

// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode';
import cookie from 'vue-cookie';
import * as Account from '../../../util/Account';

export default {
	name: 'NavBar',
	data() {
		return {
			navigation: '',
		};
	},
	computed: {
		jwtDecoded() {
			let decoded = '';
			if (cookie.get('admtoken', {
				host: window.location.host,
			}) !== null) {
				const token = cookie.get('admtoken', {
					host: window.location.host,
				});
				decoded = jwt_decode(token);
			}
			return decoded;
		},
		collapsed() {
			return this.$store.getters.getBarStatus;
		},
	},
	methods: {
		logoff() {
			Account.logoff();
		},
		changeStatus(status) {
			localStorage.setItem('barstatus', status);
			this.$store.dispatch('setBarStatus', status);
		},
	},
};
</script>

<style lang="scss" scoped>

.navbar-topo {
  position: absolute;
  padding-left: 15px;
  padding-right: 15px;
  display: flex;
  justify-content: space-between;
  height: 65px;
  width: 100%;
  align-self: center;
  align-items: center;
  border-radius: 5px;
  border: 1px solid #deebfd;
  box-shadow: -8px 12px 18px 0 #dadee8;
  background-color: #FFF;
  z-index: 70;
}
.navbar-item {
  padding: 0px !important;
}
.dropdown-exit {
  display: flex;
  align-items: center;
  padding: 5px;
}
.btn-transparent {
  all: unset;
  display: flex;
  align-self: center;
  width: 35px;
  height: 35px;
  align-items: center;
  justify-content: center;
}
.btn.focus,
.btn:focus {
  outline: 0;
  border-radius: 50%;
  background-color: rgba(0, 68, 255, 0.116);
}
.grid-icon {
  transition: 0.1s ease-in;
}
.grid-icon:hover {
  color: $primary;
}
.user-personal-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.personal-image {
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
}
.personal-image img {
  max-height: 2.75rem;
  border-radius: 20%;
}
.userName {
  margin-right: 10px;
}
.user-data {
  display: flex;
  align-items: center;
}
.userName h1 {
  font-size: 14px;
  font-weight: 500;
  color: #2b2b2b;
}

.userName h4 {
  font-size: 11px;
  color: rgba(43, 43, 43, 0.7);
}
.title-username {
  font-size: 14px;
}
.user-icon {
  margin-left: 10px;
 /*  background-color: #cecece; */
  padding: 5px;
  border-radius: 50%;
/*   color: #fff; */
}
.dropdown-menu-icon {
  margin-right: 5px;
}
</style>
